import React from 'react';
import Modal from 'react-modal';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    maxWidth:"500px",
    width: "100%",
    padding: "50px",
    fontSize: "20px"
  },  
};

export const TimeoutWarningModal = ({isOpen}) => {  
 
  return (
    <div> 
      <Modal
        isOpen={isOpen}
        style={customStyles}
        contentLabel=""
      >
        <h2>Session Timeout</h2>
        <div>You're being timed out due to inactivity, you are now be logged off automatically...!</div>
        <br/>
      </Modal>
    </div>  
  );
}

